import axios from 'axios'
import { apiHost } from '../config/env.conf'

export default {

    /**
     * 获取经营数据
     * @param { int }    bizCode   业务线，11021 跟团 11022 酒景
     * @param { string } startDate 开始日期
     * @param { string } endDate   结束日期
     */
    getOperationData (bizCode, startDate, endDate) {
        return axios.get(`trip-package-auditapi/api/biz/data/operation/get`, {
            params: {
                bizCode: bizCode,
                startDate: startDate,
                endDate: endDate
            }
        })
    },

    /**
     * 获取经营趋势数据
     * @param { int }    bizCode   业务线，11021 跟团 11022 酒景
     * @param { string } startDate 开始日期
     * @param { string } endDate   结束日期
     */
    getOperationTrendData (bizCode, startDate, endDate, moduleId) {
        return axios.get(`trip-package-auditapi/api/biz/data/operation/trend`, {
            params: {
                bizCode: bizCode,
                startDate: startDate,
                endDate: endDate,
	            moduleId: moduleId
            }
        })
    },

    /**
     * 获取单品数据运营趋势
     * @param { int }    bizCode    业务线，11021 跟团 11022 酒景
     * @param { string } startDate  开始日期
     * @param { string } endDate    结束日期
     * @param { int }    productId  单品ID
     */
    getProductTrendData (bizCode, startDate, endDate, productId) {
        return axios.get(`trip-package-auditapi/api/biz/data/product/trend`, {
            params: {
                bizCode: bizCode,
                startDate: startDate,
                endDate: endDate,
                productId: productId
            }
        })
    },

    /**
     * 获取单品数据
     * @param { int }    bizCode   业务线，11021 跟团 11022 酒景
     * @param { string } startDate 开始日期
     * @param { string } endDate   结束日期
     * @param { int }    rankType  类别
     */
    getRankTypeData (bizCode, startDate, endDate, rankType) {
        return axios.get(`trip-package-auditapi/api/biz/data/rank/get`, {
            params: {
                bizCode: bizCode,
                startDate: startDate,
                endDate: endDate,
                rankType: rankType
            }
        })
    },

    /**
     * 获取商品分析数据
     * @param { int }    bizCode     业务线，11021 跟团 11022 酒景
     * @param { string } startDate   开始日期
     * @param { string } endDate     结束日期
     * @param { int }    productId   商品ID
     * @param { string } productName 商品名称
     * @param { int }    pageId      当前页码
     * @param { int }    pageSize    每页展示条数
     */
    getProductData (bizCode, startDate, endDate, productId, productName, pageId, pageSize) {
        return axios.get(`trip-package-auditapi/api/biz/data/product/list`, {
            params: {
                bizCode: bizCode,
                startDate: startDate,
                endDate: endDate,
                productId: productId,
                productName: productName,
                pageId: pageId,
                pageSize: pageSize
            }
        })
    },

    /**
     * 全品数据下载
     * @param { int }    bizCode   业务线，11021 跟团 11022 酒景
     * @param { string } startDate 开始日期
     * @param { string } endDate   结束日期
     * @param { int }    moduleId  模块
     */
    downloadData (bizCode, startDate, endDate, moduleId) {
        window.open(`${apiHost}/trip-package-auditapi/api/biz/data/operation/download?bizCode=${bizCode}&startDate=${startDate}&endDate=${endDate}&moduleId=${moduleId}`)
    },

    /**
     * 单品数据下载
     * @param { int }    bizCode   业务线，11021 跟团 11022 酒景
     * @param { string } startDate 开始日期
     * @param { string } endDate   结束日期
     * @param { int }    moduleId  模块
     */
    downloadProductData (bizCode, startDate, endDate, moduleId, productId) {
        window.open(`${apiHost}/trip-package-auditapi/api/biz/data/product/download?bizCode=${bizCode}&startDate=${startDate}&endDate=${endDate}&moduleId=${moduleId}&productId=${productId}`)
    }

}



// WEBPACK FOOTER //
// ./src/api/dataPlatform.js